import React, { Component } from 'react';

export default class Home extends Component {
    state = {
        value: 0,
      };
    render(){
        return(
            <div>
                    <h5>Welcome to DesignLove Software </h5>
                    <br /><br />
                        <p>
                             We offer End to End solutions as well as individual components - Whether you're in the Automotive Sales industry or have a new idea like a startup, an established large corporation
                             or even a local business with a new software or component requirement -<br /> we can help you achieve this.
                             <br /><br />
                             We have over 30 years combined software engineering and systems design and development experience over desktop
                             and web and mobile software applications in the Public, Government, Private, Utilities and Media spaces.
                             
                             W also have a wealth of small business experience - so we can help take your idea from sketch to reality,
                             from ecommerce shops to a portfolio page.
                        </p> 
            </div>
        );
    }
  }


// WEBPACK FOOTER //
// ./src/components/Home.js